const pageNameKey = "findMyBlueprintLibraryModal";

export const findMyBlueprintLibraryModalEn = {
  [pageNameKey]: {
    subTitle: "Generate Structure from Blueprint Library",
    inputPlaceholder: "Enter Device/Machine Name",
    blueprint: "Blueprint",
    blueprintLibrary: "Blueprint Library",
    applyButton: "Apply Blueprint",
    cancelButton: "Cancel",
    blueprintSupportText: "Didn't find the right blueprint?",
    blueprintSupportLink: "Ask us for support",
  },
};

export const findMyBlueprintLibraryModalPtBr = {
  [pageNameKey]: {
    subTitle: "Gerar estrutura a partir da biblioteca de blueprints",
    inputPlaceholder: "Insira o nome do dispositivo/máquina",
    blueprint: "Projeto",
    blueprintLibrary: "Biblioteca de blueprints",
    applyButton: "Aplicar modelo",
    cancelButton: "Cancelar",
    blueprintSupportText: "Não encontrou o blueprint certo?",
    blueprintSupportLink: "Peça suporte à nossa equipe",
  },
};

export const findMyBlueprintLibraryModalDe = {
  [pageNameKey]: {
    subTitle: "Struktur aus Blueprint-Bibliothek generieren",
    inputPlaceholder: "Geräte-/Maschinennamen eingeben",
    blueprint: "Blueprint",
    blueprintLibrary: "Blueprint-Bibliothek",
    applyButton: "Blueprint anwenden",
    cancelButton: "Abbrechen",
    blueprintSupportText: "Den richtigen Blueprint nicht gefunden?",
    blueprintSupportLink: "Kontaktieren Sie uns",
  },
};

export const findMyBlueprintLibraryModalZhHans = {
  [pageNameKey]: {
    subTitle: "从蓝图库生成结构",
    inputPlaceholder: "输入设备/机器名称",
    blueprint: "蓝图",
    blueprintLibrary: "蓝图库",
    applyButton: "应用蓝图",
    cancelButton: "取消",
    blueprintSupportText: "没有找到合适的蓝图？",
    blueprintSupportLink: "联系我们获取支持",
  },
};

export const findMyBlueprintLibraryModalIt = {
  [pageNameKey]: {
    subTitle: "Genera Struttura dalla libreria Blueprint",
    inputPlaceholder: "Inserisci il nome del dispositivo/macchina",
    blueprint: "Blueprint",
    blueprintLibrary: "Libreria di Blueprint",
    applyButton: "Applica Blueprint",
    cancelButton: "Annulla",
    blueprintSupportText: "Non hai trovato il Blueprint giusto?",
    blueprintSupportLink: "Richiedi supporto",
  },
};

export const findMyBlueprintLibraryModalEs = {
  [pageNameKey]: {
    subTitle: "Generar estructura desde la biblioteca de planos",
    inputPlaceholder: "Ingrese el nombre del dispositivo/máquina",
    blueprint: "Plano",
    blueprintLibrary: "Biblioteca de planos",
    applyButton: "Aplicar plano",
    cancelButton: "Cancelar",
    blueprintSupportText: "¿No encontraste el plano adecuado?",
    blueprintSupportLink: "Pídenos ayuda",
  },
};

export const findMyBlueprintLibraryModalNl = {
  [pageNameKey]: {
    applyButton: "Blueprint toepassen",
    blueprint: "Blueprint",
    blueprintLibrary: "Blueprint-bibliotheek",
    blueprintSupportText: "Niet de juiste blueprint gevonden?",
    cancelButton: "Annuleren",
    inputPlaceholder: "Apparaat-/machinenaam invoeren",
    subTitle: "Structuur genereren van uit blueprint-bibliotheek",
    blueprintSupportLink: "Vraag ons om ondersteuning",
  },
};

export const findMyBlueprintLibraryModalTr = {
  [pageNameKey]: {
    applyButton: "Planı Uygula",
    blueprint: "Taslak",
    blueprintLibrary: "Plan Kitaplığı",
    blueprintSupportLink: "Bizden destek isteyin",
    blueprintSupportText: "Doğru planı bulamadınız mı?",
    cancelButton: "İptal etmek",
    inputPlaceholder: "Cihaz/Makine Adını Girin",
    subTitle: "Blueprint Kitaplığından Yapı Oluşturma",
  },
};
